import React from 'react';
import styled from 'styled-components';
import { COLOR_ACCENT, COLOR_DESCRIPTION, COLOR_PRIMARY, COLOR_SECONDARY, DEVICES } from '../../const';
import logo from '../../assets/logo.png';

const Container = styled.div`
  background-color: #fff;
  position: relative;
  @media ${DEVICES.mobile} {
    padding: 40px 0;
  }

  @media ${DEVICES.tablet} {
    padding: 120px 0;
  }
`;

const BackgroundImg = styled.img`
  position: absolute;
  height: 100%;
  right: -300px;
  top: 0;
  filter: blur(8px);
  opacity: 0.4;

  @media ${DEVICES.mobile} {
    display: none;
  }

  @media ${DEVICES.tablet} {
    display: block;
  }
`;

const Inner = styled.div`
  margin: auto;

  @media ${DEVICES.mobile} {
    display: block;
  }

  @media ${DEVICES.tablet} {
    display: flex;
    align-items: center;
  }

  @media ${DEVICES.large} {
    display: flex;
    max-width: 1200px;
    align-items: center;
  }
`;

const Right = styled.div`
  padding: 2rem;
  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const RightHeading = styled.div`
  font-weight: 700;
  color: ${COLOR_ACCENT};
  
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }
  
  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
  }

  @media ${DEVICES.laptop} {
  }
`;

const RightTitle = styled.div`
  font-weight: 700;
  line-height: 1.3;
  
  @media ${DEVICES.mobile} {
    margin-top: 1rem;
    font-size: 2rem;
  }
  
  @media ${DEVICES.tablet} {
    margin-top: 1.5rem;
    font-size: 1.5rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 2.25rem;
  }
`;

const RightDescription = styled.div`
  margin-top: 2.5rem;
  color: ${COLOR_DESCRIPTION};
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 0.8rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const RightDescriptionBold = styled.div`
  margin-top: 1rem;
  font-weight: 700;
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 0.8rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const Left = styled.div`
  padding: 2rem;
  @media ${DEVICES.mobile} {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const LeftImg = styled.img`
  width: 100%;
  border-radius: 20px;
`;

export default function StrengthDataBanner() {
  return (
    <Container>
      <BackgroundImg src='https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/home/strength_data_background.png' />
      <Inner>
        <Left>
          <LeftImg src='https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/home/strength_data.jpeg' />
        </Left>
        <Right>
          <RightHeading>
            OUR FEATURES. 03
          </RightHeading>
          <RightTitle>
            데이터를 기반으로 제공하는 <br />
            객관적인 피드백
          </RightTitle>
          <RightDescription>
            우리 아이들이 운동을 하면서 향상되는 모습을
            상세히 살펴 볼 수 있습니다
          </RightDescription>
          <RightDescriptionBold>
            향후 축적된 데이터를 바탕으로 아이에게 <br />
            적절한 운동 솔루션을 제공해 드립니다
          </RightDescriptionBold>
        </Right>
      </Inner>
    </Container>
  )
}
